import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-target": "#course-trainnning-statistics",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Course Wise Training Statistics Report ")
  ])
], -1)
const _hoisted_3 = {
  id: "course-trainnning-statistics",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Trainee Type", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { class: "col-md-3 mt-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_15 = {
  key: 1,
  disabled: "",
  type: "button",
  class: "btn btn-success mt-6 p-3",
  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_17 = { class: "position-relative" }
const _hoisted_18 = {
  id: "courseTReport",
  class: "collapse show"
}
const _hoisted_19 = { class: "collapse show" }
const _hoisted_20 = { class: "card-body p-0 mt-7" }
const _hoisted_21 = { class: "row w-100 mb-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 my-auto" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "m-0" }, "Course Wise Training Statistics Report")
], -1)
const _hoisted_23 = {
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "table-responsive mt-3" }
const _hoisted_31 = {
  class: "table table-borderless",
  style: {"border":"1.5px solid black"}
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("thead", { style: {"border-left":"1.5px solid black"} }, [
  /*#__PURE__*/_createElementVNode("tr", {
    class: "fw-bolder bg-light text-black",
    style: {"border-bottom":"1px solid black"}
  }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Sl "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Course Name "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Total Target (As Per Contract) "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      colspan: "3"
    }, " Enrollment "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      colspan: "3"
    }, " Assessment "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      colspan: "3"
    }, " Certifications "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      colspan: "3"
    }, " Job Placement "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " % of Job Placement on Certification ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", {
    class: "fw-bolder bg-light text-black",
    style: {"border-bottom":"1px solid black"}
  }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, "Total"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, "Female"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " % of Female "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, "Total"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, "Female"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " % of Female "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, "Total"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, "Female"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " % of Female "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, "Total"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, "Female"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " % of Female ")
  ])
], -1)
const _hoisted_33 = { style: {} }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = {
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "16"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("tr", null, null, -1)
const _hoisted_37 = {
  key: 1,
  class: "fw-bolder border border-gray-400 text-center"
}
const _hoisted_38 = { colspan: "2" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { class: "fw-bolder border border-gray-400 text-center" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Grand Total (All Tranches) ")
], -1)
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.entity_id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.entity_id) = $event)),
                  options: _ctx.optionsTPartner,
                  mode: "tags",
                  "clear-on-select": false,
                  placeholder: "Select Training Partner",
                  "close-on-select": false,
                  searchable: true,
                  "create-option": true,
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.btnCheckStatus()))
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _hoisted_12,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "--Select--",
                  modelValue: _ctx.report_type,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.report_type) = $event)),
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, { value: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode("--Select--")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      value: "1",
                      label: "Ethnic Minority"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Ethnic Minority")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      value: "2",
                      label: "Physically Disable"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Physically Disable")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                (_ctx.btnCheck)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.courseTrainningStatistics())),
                      type: "button",
                      class: "btn btn-success mt-6 p-3",
                      style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                    }, [
                      _createTextVNode(" Search "),
                      _hoisted_14
                    ]))
                  : (_openBlock(), _createElementBlock("button", _hoisted_15, [
                      _createTextVNode(" Search "),
                      _hoisted_16
                    ]))
              ])
            ]),
            (_ctx.showTrainningStatistics == true)
              ? _withDirectives((_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _hoisted_22,
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                                title: "Download Xlse",
                                "data-v-54b12dc8": "",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.exportTrainee()))
                              }, _hoisted_25),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                                title: "Download PDF",
                                "data-v-54b12dc8": "",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.downloadPdf()))
                              }, _hoisted_27),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                                title: "Print",
                                "data-v-54b12dc8": "",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.printPdf()))
                              }, _hoisted_29)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("table", _hoisted_31, [
                              _hoisted_32,
                              _createElementVNode("tbody", _hoisted_33, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.activityReport, (info, key) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                                    (info?.trancheInfo?.course.length > 0)
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_34, [
                                          _createElementVNode("td", _hoisted_35, [
                                            _createElementVNode("b", null, _toDisplayString(info?.trancheInfo?.label), 1)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _hoisted_36,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info?.trancheInfo
                                  ?.course, (data, inx) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: inx,
                                        class: "border border-gray-400 text-center"
                                      }, [
                                        _createElementVNode("td", null, _toDisplayString(inx + 1), 1),
                                        _createElementVNode("td", null, _toDisplayString(data?.course_name), 1),
                                        _createElementVNode("td", null, _toDisplayString(data?.targetTrainee), 1),
                                        _createElementVNode("td", null, _toDisplayString(data?.enrollment), 1),
                                        _createElementVNode("td", null, _toDisplayString(data?.femaleEnroll), 1),
                                        _createElementVNode("td", null, _toDisplayString(data?.femaleEnrollPercentage), 1),
                                        _createElementVNode("td", null, _toDisplayString(data?.assesment), 1),
                                        _createElementVNode("td", null, _toDisplayString(data?.femaleAssesment), 1),
                                        _createElementVNode("td", null, _toDisplayString(data?.femaleAssesmentPercentage), 1),
                                        _createElementVNode("td", null, _toDisplayString(data?.certification), 1),
                                        _createElementVNode("td", null, _toDisplayString(data?.femaleCertification), 1),
                                        _createElementVNode("td", null, _toDisplayString(data?.femaleCertificationPercentage), 1),
                                        _createElementVNode("td", null, _toDisplayString(data?.job_placement), 1),
                                        _createElementVNode("td", null, _toDisplayString(data?.female_job_placement), 1),
                                        _createElementVNode("td", null, _toDisplayString(data?.female_job_placement_percentage), 1),
                                        _createElementVNode("td", null, _toDisplayString(data?.certification_job_placement__percentage), 1)
                                      ]))
                                    }), 128)),
                                    (info?.trancheInfo?.course.length > 0)
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_37, [
                                          _createElementVNode("td", _hoisted_38, [
                                            _createElementVNode("b", null, " Subtotal(" + _toDisplayString(info?.trancheInfo?.label) + ")", 1)
                                          ]),
                                          _createElementVNode("td", null, _toDisplayString(info?.trancheInfo?.subTotalTrainee), 1),
                                          _createElementVNode("td", null, _toDisplayString(info?.trancheInfo?.subTotalenrollment), 1),
                                          _createElementVNode("td", null, _toDisplayString(info?.trancheInfo
                                        ?.subTotalenrollmentFemale), 1),
                                          _createElementVNode("td", null, [
                                            (info?.trancheInfo?.subTotalenrollmentFemale > 0)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString((
                                            (info?.trancheInfo?.subTotalenrollmentFemale /info?.trancheInfo?.subTotalenrollment) *100
                                          ).toFixed(2)), 1))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_40, "0.00"))
                                          ]),
                                          _createElementVNode("td", null, _toDisplayString(info?.trancheInfo?.subTotalassesment), 1),
                                          _createElementVNode("td", null, _toDisplayString(info?.trancheInfo
                                        ?.subTotalassesmentFemale), 1),
                                          _createElementVNode("td", null, [
                                            (info?.trancheInfo?.subTotalassesmentFemale > 0)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString((
                                            (info?.trancheInfo?.subTotalassesmentFemale /info?.trancheInfo?.subTotalassesment) *100
                                          ).toFixed(2)), 1))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_42, "0.00"))
                                          ]),
                                          _createElementVNode("td", null, _toDisplayString(info?.trancheInfo?.subTotalcertification), 1),
                                          _createElementVNode("td", null, _toDisplayString(info?.trancheInfo
                                        ?.subTotalcertificationFemale), 1),
                                          _createElementVNode("td", null, [
                                            (info?.trancheInfo?.subTotalcertificationFemale > 0)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString((
                                            (info?.trancheInfo?.subTotalcertificationFemale /info?.trancheInfo?.subTotalcertification) *100
                                          ).toFixed(2)), 1))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_44, "0.00"))
                                          ]),
                                          _createElementVNode("td", null, _toDisplayString(info?.trancheInfo?.subTotaljobplacement), 1),
                                          _createElementVNode("td", null, _toDisplayString(info?.trancheInfo
                                        ?.subTotaljobplacementFemale), 1),
                                          _createElementVNode("td", null, [
                                            (info?.trancheInfo?.subTotaljobplacementFemale > 0)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString((
                                            (info?.trancheInfo?.subTotaljobplacementFemale /info?.trancheInfo?.subTotaljobplacement) *100
                                          ).toFixed(2)), 1))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_46, "0.00"))
                                          ]),
                                          _createElementVNode("td", null, [
                                            (info?.trancheInfo?.subTotaljobplacement > 0)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString((
                                            (info?.trancheInfo?.subTotaljobplacement /info?.trancheInfo?.subTotalcertification) *100
                                          ).toFixed(2)), 1))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_48, "0.00"))
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 128)),
                                _createElementVNode("tr", _hoisted_49, [
                                  _hoisted_50,
                                  _createElementVNode("td", null, _toDisplayString(this.TotalTrainee), 1),
                                  _createElementVNode("td", null, _toDisplayString(this.Totalenrollment), 1),
                                  _createElementVNode("td", null, _toDisplayString(this.TotalenrollmentFemale), 1),
                                  _createElementVNode("td", null, [
                                    (this.TotalenrollmentFemale > 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(((this.TotalenrollmentFemale/this.Totalenrollment) *100).toFixed(2)), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_52, "0.00"))
                                  ]),
                                  _createElementVNode("td", null, _toDisplayString(this.Totalassesment), 1),
                                  _createElementVNode("td", null, _toDisplayString(this.TotalassesmentFemale), 1),
                                  _createElementVNode("td", null, [
                                    (this.TotalassesmentFemale > 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(((this.TotalassesmentFemale/this.Totalassesment) *100).toFixed(2)), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_54, "0.00"))
                                  ]),
                                  _createElementVNode("td", null, _toDisplayString(this.Totalcertification), 1),
                                  _createElementVNode("td", null, _toDisplayString(this.TotalcertificationFemale), 1),
                                  _createElementVNode("td", null, [
                                    (this.TotalcertificationFemale > 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(((this.TotalcertificationFemale/this.Totalcertification) *100).toFixed(2)), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_56, "0.00"))
                                  ]),
                                  _createElementVNode("td", null, _toDisplayString(this.Totaljobplacement), 1),
                                  _createElementVNode("td", null, _toDisplayString(this.TotaljobplacementFemale), 1),
                                  _createElementVNode("td", null, [
                                    (this.TotaljobplacementFemale > 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(((this.TotaljobplacementFemale/this.Totaljobplacement) *100).toFixed(2)), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_58, "0.00"))
                                  ]),
                                  _createElementVNode("td", null, [
                                    (this.Totaljobplacement > 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(((this.Totaljobplacement/this.Totalcertification) *100).toFixed(2)), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_60, "0.00"))
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])), [
                      [_directive_loading, _ctx.load]
                    ])
                  ])
                ])), [
                  [_directive_loading, _ctx.load]
                ])
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}